import React, { Component } from 'react';
import Loader from '../loader';
import Wix from '../../services/wix-sdk-polyfill';
import styles from './overlay-loader.scss';

class OverlayLoader extends Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    Wix.getBoundingRectAndOffsets(({ rect }) => {
      this.setState({
        isLoading: true,
        top: Math.max(-rect.top, 0),
      });
    });
  }

  render() {
    const { top, isLoading } = this.state;
    const loader = isLoading ? (
      <div className={styles.loader} style={{ top }} key="loader">
        <Loader bubbleClassName={styles.loaderBubble} />
      </div>
    ) : null;
    return <div className={styles.container}>{loader}</div>;
  }
}

export default OverlayLoader;
